// components/router/RequireCustomer.tsx
import { Navigate, Outlet } from "react-router-dom";
import { useStateContext } from "../../contexts/ContextProvider";
import Loader from "../dataDisplay/Loader";

export default function RequireCustomer() {
    const { token, user, isUserLoading } = useStateContext();

    if (!token) return <Navigate to="/login" replace />;

    if (isUserLoading) {
        return <Loader message="chargement" useNeutralLoader={true} />;
    }

    if (!user?.customer_id) {
        return <Navigate to="/dashboard" replace />;
    }

    return <Outlet />;
}
